import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import PVOffering from "@/pages/PVOffering";

export const Route = createFileRoute("/zh-cn/services/pharmacovigilance/pv-audits-inspections-quality-system-management")({
  head: () => buildRouteHead("/zh-cn/services/pharmacovigilance/pv-audits-inspections-quality-system-management"),
  component: PVOffering,
});

